import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';

export const toPhoneString = (value?: string | number | null): string => {
  const digits = stripNonNumericCharacters(value).slice(0, 10);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= 3) {
    return `(${digits}`;
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
